<template>
    <div class="box">
        <div class="tabbar" v-if="!isApp" :class="navBarFixed ? 'navBarFixed' : ''">
            <img @click="goback" src="../../../../static/common/logo.png" alt="" />
        </div>
        <img class="banner" src="/subject/newYear2025/banner.png" alt="" />
        <img class="banners" src="/subject/newYear2025/wap/banner.png" alt="" />

        <div class="top-list">
            <img @click="showRule" src="/subject/newYear2025/rule.png" alt="">
            <img v-if="isApp && !isLogin" @click="toLogin" src="/subject/newYear2025/join.png" alt="">
            <img v-if="isApp && isLogin" @click="toTrade" src="/subject/newYear2025/join.png" alt="">
            <img v-if="isPC" @click="joinActivity" src="/subject/newYear2025/join.png" alt="">
        </div>
        <div class="content">
            <div class="part">
                <div class="part1">
                    <div>

                        <div class="img-box1">
                            <img src="/subject/newYear2025/step1.png" alt="">
                            <img src="/subject/newYear2025/title4.png" alt="">
                        </div>
                        <div class="neirong">
                            <img src="/subject/newYear2025/step2.png" alt="">
                            <img src="/subject/newYear2025/red-packet.png" alt="">

                        </div>
                        <div class="cont">
                            <img src="/subject/newYear2025/content.png" alt="">

                        </div>
                        <div class="anniu">
                            <div class="anniu-div" @click="live800"></div>
                            <img v-if="isApp && !isLogin" class="anniu-img" @click="toLogin"
                                src="/subject/newYear2025/join-btn.png" alt="">
                            <img v-if="isApp && isLogin" class="anniu-img" @click="toTrade"
                                src="/subject/newYear2025/join-btn.png" alt="">
                            <img v-if="isPC" class="anniu-img" @click="joinActivity"
                                src="/subject/newYear2025/join-btn.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="wappart1">
                    <div>

                        <div class="img-box1">
                            <img src="/subject/newYear2025/wap/step1.png" alt="">
                            <img src="/subject/newYear2025/wap/cart.png" alt="">
                        </div>
                        <div class="neirong">
                            <img src="/subject/newYear2025/wap/step2.png" alt="">
                            <img src="/subject/newYear2025/wap/red_packet.png" alt="">

                        </div>
                        <div class="cont">
                            <img src="/subject/newYear2025/wap/content.png" alt="">

                        </div>
                        <div class="anniu">
                            <div class="anniu-div" @click="live800"></div>
                            <img v-if="isApp && !isLogin" class="anniu-img" @click="toLogin"
                                src="/subject/newYear2025/join-btn.png" alt="">
                            <img v-if="isApp && isLogin" class="anniu-img" @click="toTrade"
                                src="/subject/newYear2025/join-btn.png" alt="">
                            <img v-if="isPC" class="anniu-img" @click="joinActivity"
                                src="/subject/newYear2025/join-btn.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="part2 clearfix">

                    <div class="detailTable">
                        <el-table :data="tableData" stripe border style="width: 1130px;margin: 0 auto;"
                            :header-cell-style="{ textAlign: 'center', color: '#d10000', border: 'none' }"
                            :header-row-style="{ height: '80px', background: 'linear-gradient(to right, #ffe9bf, #ffd9a2)' }"
                            :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                            <el-table-column prop="date" label="行为" min-width="40%">
                            </el-table-column>
                            <el-table-column prop="name" label="日常得分" min-width="30%">
                            </el-table-column>
                            <el-table-column prop="address" label="活动期间得分" min-width="40%">
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="anniu">
                        <div class="anniu-div" @click="live800"></div>

                        <img v-if="isApp && !isLogin" class="anniu-img" @click="toLogin"
                            src="/subject/newYear2025/join-btn.png" alt="">
                        <img v-if="isApp && isLogin" class="anniu-img" @click="toTrade"
                            src="/subject/newYear2025/join-btn.png" alt="">
                        <img v-if="isPC" class="anniu-img" @click="joinActivity" src="/subject/newYear2025/join-btn.png"
                            alt="">
                    </div>
                </div>
                <div class="part3" ref="targetTops" 
                    >
                    <div class=" title">
                        1月27--2月12日限时开启
                    </div>
                    <img class="tree" src="/subject/newYear2025/tree.png" alt="">
                    <img class="trees" src="/subject/newYear2025/wap/tree.png" alt="">
                    <div class="history">
                        <span>可用次数: {{ totalNum }}</span>
                        <img @click="startCallback" class="shake" src="/subject/newYear2025/buttom1.png" alt="">
                        <img @click="startCallback" class="shakes" src="/subject/newYear2025/wap/shake.png" alt="">
                        <span @click="historyOff">中奖记录></span>
                    </div>
                    <div class="drawlist">

                        <div>
                            <span>每日登录活动页，可领取1次机会（{{ getnumber }}/1）</span>
                            <img src="/subject/newYear2025/button1.png" v-if="getStatus" alt="">
                            <img src="/subject/newYear2025/draw-down.png" @click="getNumber(9)" v-else alt="">
                        </div>
                        <div>
                            <span>消耗100积分兑换1次机会。每日最多兑换4次。（{{ vertifyNumber }}/4）</span>
                            <img src="/subject/newYear2025/button.png" v-if="vertifyStaus" alt="">
                            <img src="/subject/newYear2025/draw.png" @click="vertifyBtn('100')" v-else alt="">
                        </div>
                        <div>
                            <span>消耗200积分兑换1次机会，每日最多兑换5次。（{{ vertifyNumber1 }}/5）</span>
                            <img src="/subject/newYear2025/button.png" v-if="vertifyStaus1" alt="">
                            <img src="/subject/newYear2025/draw.png" v-else @click="vertifyBtn('200')" alt="">
                        </div>
                    </div>
                </div>
                <div class="part4" v-if="!isApp" ref="targetElement">
                    <div class="left">
                        <div class="top-box">
                            <div @click="activeIndex = 0" :class="activeIndex == 0 ? 'active flex' : 'default flex'">
                                <span>MT4账户专用版本</span>

                            </div>
                            <div @click="activeIndex = 1" :class="activeIndex == 1 ? 'active flex' : 'default flex'">
                                <span>MT5账户专用版本</span>

                            </div>
                        </div>

                        <div class="mt4cont" v-if="activeIndex == 0">
                            <div class="codeBoxs">
                                <Qrcode :link="iosMt4DownloadUrl" :size="126" :iconSize="30" />


                            </div>
                            <div class="ios">ios</div>
                            <div class="codeBoxs">
                                <Qrcode :link="androidMt4DownloadUrl" :size="126" />

                            </div>
                            <div class="ios">Android</div>
                        </div>
                        <div class="mt4cont" v-if="activeIndex == 1">
                            <div class="codeBoxs">
                                <Qrcode :link="iosMt5DownloadUrl" :size="126" />


                            </div>
                            <div class="ios">ios</div>
                            <div class="codeBoxs">
                                <Qrcode :link="androidDownloadUrl" :size="126" />


                            </div>
                            <div class="ios">Android</div>
                        </div>



                        <div class="cont">
                            <p>1、MT4版本用MT4账户，MT5版本用
                                MT5账户，两者不互通；</p>
                            <p> 2、如无法确定所用账户的MT版本，请
                                联系在线客服查询。</p>
                        </div>
                    </div>
                    <img class="phone" src="/subject/newYear2025/phone.png" alt="">
                    <img class="phones" src="/subject/newYear2025/wap/phone.png" alt="">
                    <img class="right" src="/subject/newYear2025/advantage.png" alt="">

                    <div class="lefts">
                        <div class="top-box">
                            <div @click="activeIndex = 0" :class="activeIndex == 0 ? 'active flex' : 'default flex'">
                                <span>MT4账户专用版本</span>

                            </div>
                            <div @click="activeIndex = 1" :class="activeIndex == 1 ? 'active flex' : 'default flex'">
                                <span>MT5账户专用版本</span>

                            </div>
                        </div>
                        <div class="mt4cont" v-if="activeIndex == 0">

                            <div @click="iosDownLoad">
                                <img src="/subject/newYear2025/wap/iOS.png" alt="">
                                <img class="iosload" src="/subject/newYear2025/wap/iosload.png" alt="">

                            </div>
                            <div @click="androidDownLoad">
                                <img src="/subject/newYear2025/wap/android.png" alt="">
                                <img class="iosload" src="/subject/newYear2025/wap/androidload.png" alt="">

                            </div>


                        </div>
                        <div class="mt4cont" v-if="activeIndex == 1">
                            <div @click="iosDownLoad1">
                                <img src="/subject/newYear2025/wap/iOS.png" alt="">
                                <img class="iosload" src="/subject/newYear2025/wap/iosload.png" alt="">

                            </div>
                            <div @click="androidDownLoad1">
                                <img src="/subject/newYear2025/wap/android.png" alt="">
                                <img class="iosload" src="/subject/newYear2025/wap/androidload.png" alt="">

                            </div>
                        </div>
                        <div class="cont">
                            <p>1、MT4版本用MT4账户，MT5版本用
                                MT5账户，两者不互通；</p>
                            <p> 2、如无法确定所用账户的MT版本，请
                                联系在线客服查询。</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="sliderBox" v-if="slider" @click="tosCroll">

            <img @click="slider = false" class="user-info-close" src="/subject/newYear2025/close.png" alt="" />
        </div>
        <el-dialog :visible.sync="showDialogs" :showClose="false" width="0px" height="0" style="padding: 0;"
            custom-class="showdialog">
            <div class="showdialog">
                <img class="closer" @click="showDialogs = false" src="/subject/newYear2025/close.png" alt="" />

                <div class="dialog">

                    <h3>活动规则</h3>

                    <ul class="dialogContent">

                        <li>
                            <span>活动时间：</span><br />
                            即日起—2025年2月15日23：59<br />
                            限时摇钱树2025年1月27日00：00—2025年2月12日23：59
                        </li>
                        <li>
                            <span>参与对象</span><br />
                            所有平台用户

                        </li>
                        <li>
                            <span>活动一、充值送100%赠金，交易享高额返现</span><br />
                            1、活动期间充值送等额赠金<br />
                            2、本活动获得的赠金无法和新用户活动叠加领取。<br />
                            3、交易品种限伦敦金、伦敦银。<br />
                            4、活动期间，赠金返现额度提升。

                        </li>
                        <div class="detailTable">
                            <el-table :data="tableData1" stripe border style="width: 468px;margin: 0 auto;"
                                :header-cell-style="{ textAlign: 'center', color: '#222', border: 'none', background: '#ffcd83' }"
                                :cell-style="{ textAlign: 'center', borderRight: 'none' }">

                                <el-table-column prop="name" label="月交易量" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="value" label="每手返还" min-width="40%">
                                </el-table-column>
                            </el-table>
                        </div>
                        <li>
                            <span>活动二、双倍积分大放送</span><br />
                            活动期间获得的积分自动翻倍。


                        </li>
                        <li>
                            <span>活动三、限时摇钱树，摇出100元现金大奖</span><br />

                            1、每天可免费领取1次摇一摇机会。<br />
                            2、可使用积分兑换额外次数。消耗100积分兑换1次摇一摇，
                            每天最多兑换4次。消耗200积分兑换1次摇一摇，每天最多兑
                            换5次。<br />
                            3、获得的奖励将实时发放到账户。
                        </li>
                        <div class="detailTable">
                            <el-table :data="tableData2" stripe border style="width: 468px;margin: 0 auto;"
                                :header-cell-style="{ textAlign: 'center', color: '#222', border: 'none', background: '#ffcd83' }"
                                :cell-style="{ textAlign: 'center', borderRight: 'none' }">
                                <el-table-column prop="number" label="序号" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="name" label="奖励" min-width="40%">
                                </el-table-column>
                                <el-table-column prop="value" label="备注" min-width="40%">
                                </el-table-column>
                            </el-table>
                        </div>
                        <li>
                            <span>注意事项</span><br />

                            1、客户参与活动需在本公司开立真实交易账户,参与该活动的新用户，为保证资金安全，在初始L1层级，账户强平比例上调至50%，升级后自动恢复为30%。<br />
                            2、交易手数计算：开仓一手平仓一手，如此来回算一手。<br />
                            3、本公司保留随时修订、暂停、终止本活动及任何相关规则条款之权利及其解释权。
                        </li>

                    </ul>
                </div>

            </div>
        </el-dialog>

        <!-- 次数不足 -->
        <el-dialog :visible.sync="showUnderLog" :showClose="false" width="0px" height="0" style="padding: 0;">
            <div class="underlog" v-if="vertifyShow">
                <img class="closer" @click="closeDialog" src="/subject/newYear2025/close.png" alt="" />

                <img src="/subject/newYear2025/hints.png" alt="">
                <span class="title">兑换成功</span>
                <img class="closes" @click="closeDialog" src="/subject/newYear2025/vertify.png" alt="">
            </div>
            <div class="underlog" v-if="shakeShow">
                <img class="closer" @click="closeDialog" src="/subject/newYear2025/close.png" alt="" />

                <img src="/subject/newYear2025/hints.png" alt="">
                <span class="title">恭喜您，</span>
                <span class="title">摇到了xxxxxxx</span>
                <img class="closes" @click="closeDialog" src="/subject/newYear2025/vertify.png" alt="">
            </div>
            <div class="underlog" v-if="shakeDown">
                <img class="closer" @click="closeDialog" src="/subject/newYear2025/close.png" alt="" />

                <img src="/subject/newYear2025/shake.png" alt="">
                <span class="title">确定使用<span style="color: #ff3a2d;">{{ intergral }}积分</span></span>
                <span>兑换一次摇一摇？</span>
                <img class="closes" @click="closeDialogs" src="/subject/newYear2025/vertify.png" alt="">
            </div>
            <div class="underlog" v-if="intergralShow">
                <img class="closer" @click="closeDialog" src="/subject/newYear2025/close.png" alt="" />

                <img src="/subject/newYear2025/hints.png" alt="">
                <span class="title">积分不足</span>
                <img class="closes" @click="closeDialog" src="/subject/newYear2025/vertify.png" alt="">
            </div>
            <!-- 次数不足 -->
            <div class="underlog" v-if="timesShow">
                <img class="closer" @click="closeDialog" src="/subject/newYear2025/close.png" alt="" />

                <img src="/subject/newYear2025/hints.png" alt="">
                <span class="title">次数不足</span>
                <img class="closes" @click="closeDialog" src="/subject/newYear2025/vertify.png" alt="">
            </div>
            <!--  -->

        </el-dialog>
        <!-- 抽奖记录 -->
        <el-dialog :visible.sync="showHistory" :showClose="false" width="342px" height="0" custom-class="underlogs1">
            <div class="underlogs">
                <img class="closer" @click="closeHistory" src="/subject/newYear2025/close.png" alt="" />
                <span class="titles">抽奖记录</span>
                <div class="lists">
                    <div v-for="(item, index) in historyList" :key="index">
                        {{ item.time + ',' }}{{ '获得' + item.value }}
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 抽奖动画 -->
        <el-dialog :visible.sync="gifsDialog" :showClose="false" width="0px" height="0" style="padding: 0;"
            custom-class="underlogs2" :close-on-click-modal="false" :close-on-press-escape="false">
            <div class="underlogs2">
                <img class="closer" @click="closeHistory" src="/subject/newYear2025/close.png" alt="" />

                <img class="gifimg" v-if="gifShow" src="../../../assets/imgs/home/trees.gif" alt="" />
                <div v-if="isOpened" class="blind-box" :class="{ glowing: isOpened }">
                    {{ messTitle }}
                </div>
            </div>
        </el-dialog>

        <!-- 登录注册 -->
        <el-dialog :visible.sync="loginDialog" :showClose="false" width="0px" height="50px" custom-class="loginDialogs">
            <div class="loginDialogs">
                <img class="closer" @click="closeHistory" src="/subject/newYear2025/close.png" alt="" />
                <div :class="actives == 1 ? 'login logins' : 'login'">
                    <div class="logintitle">
                        <span @click="selectlogin(0)">登录</span>
                        <span @click="selectlogin(1)">注册</span>
                    </div>
                    <div class="interactive">


                        <input v-if="isNumber" ref="inputElement" type="text" v-model="form.phone"
                            placeholder="请输入交易账号/手机号" @blur="changePhone" />
                        <input v-model="form.phone" v-else ref="inputElement" type="text" placeholder="请输入手机号"
                            @blur="changePhone" />

                        <div class="codeBox" v-if="isNumber">
                            <input v-model="form.password" placeholder="请输入密码" show-password maxlength="20" />
                        </div>
                        <div class="codeBox" v-else>
                            <input v-model="form.code" type="text" placeholder="请输入验证码" />
                            <span v-if="verControl" @click="verCode(form.phone)">获取验证码</span>
                            <span v-else>重新获取({{ verSecond }})</span>
                        </div>
                        <div v-if="actives ==0" class="titleLogin">
                            <span v-if="isNumber" @click="selectAccount1">验证码登录</span>

                            <span v-else @click="selectAccount">账号登录</span>
                        </div>
                        <div class="buttom" @click="submit1(form)" v-if="isNumber">
                            登录
                        </div>
                        <div class="buttom" @click="submit(form)" v-else>
                            {{ actives == 1 ? '注册' : '登录' }}
                        </div>
                    </div>

                </div>

            </div>
        </el-dialog>

    </div>
</template>

<script>
import {

    searchUserNum,
    luckDraw,
    searchUserHistory,


} from '../../../../api/info';
import {
    exchangeNumNew,
    getexchangeNum
} from '@/apis/active';

import awardId from './global';
import Qrcode from "@/component/QrCode/index.vue";
import { mapState, mapActions } from "vuex";
import userSign from '@/mixins/userSign';
import { postLogin } from '@/apis/user';
import { encryptCBC } from "@/utils/IMEI";
import { setToken, getToken, deleteToken } from "@/utils/cookies";
import { Loading } from 'element-ui';


export default {
    components: {

        Qrcode,
    },
    mixins: [userSign],

    data() {
        return {

            navBarFixed: false,
            scroll: "",
            screenWidth: null,
            slider: true,
            showDialog: false,
            formattedDateString: '',
            timer: null,
            qrCodeUrl: '',
            activeIndex: 0,
            tableData: [{
                date: '每充值100美元',
                name: '+ 1',
                address: '+ 2'
            }, {
                date: '每交易1手金 / 银',
                name: '+ 1',
                address: '+ 2'
            }, {
                date: '每个产品首次交易',
                name: '+ 100',
                address: '+ 200'
            }, {
                date: '每成功推荐1个好友入金',
                name: '+ 100',
                address: '+ 200'
            }, {
                date: '新人首次入金',
                name: '+ 100',
                address: '+ 200'
            }, {
                date: '完成基础认证',
                name: '+ 100',
                address: '+ 200'
            },],

            tableData1: [
                {
                    name: '0.01-10手',
                    value: '3美元'
                },
                {
                    name: '10.01-30手',
                    value: '4美元'
                },
                {
                    name: '30.01-50手',
                    value: '5美元'
                },
                {
                    name: '50.01手以上',
                    value: '7美元'
                },
            ],
            tableData2: [

                {
                    number: '1',
                    name: '$50赠金',
                    value: '有效期30天'
                },
                {
                    number: '2',
                    name: '$150赠金',
                    value: '有效期30天'
                },
                {
                    number: '3',
                    name: '$100金银卡劵',
                    value: '有效期7天，最高可提现4美元'
                },
                {
                    number: '4',
                    name: '50积分',
                    value: '长期有效'
                },
                {
                    number: '5',
                    name: '200积分',
                    value: '长期有效'
                },
                {
                    number: '6',
                    name: '￥10红包',
                    value: ' 按照实时入金汇率，兑换成美元打入账户'
                },
                {
                    number: '7',
                    name: '￥100红包',
                    value: ' 按照实时入金汇率，兑换成美元打入账户'

                },
            ],

            showDialogs: false,//规则
            showUnderLog: false,//摇一摇涉及到的弹框
            timesShow: false,//次数不足
            intergralShow: false,//积分不足
            vertifyShow: false,//兑换成功
            shakeShow: false,//摇到了
            shakeDown: false,//积分兑换
            intergral: null,//积分
            showHistory: false,//历史记录
            // 抽奖记录
            historyList: [

            ],
            drawsNumber: 0,//剩余次数,
            getnumber: 0,//今日领取次数
            getStatus: false,//今日领取状态
            vertifyNumber: 0,//积分兑换100
            vertifyNumber1: 0,//积分兑换200
            vertifyStaus: false,
            vertifyStaus1: false,
            isOpened: false,//动画展示
            gifsDialog: false,//动图动画
            gifShow: false,//动图
            totalNum: 0,
            prizesList: [],
            messTitle: '',//摇一摇结果
            loginStatus: false,//登录状态
            loginDialog: false,//登录注册弹框
            actives: 0,
            isApp: false,
            isLogin: false,
            isPC: true,
            isNumber:false,//是否账号密码登录
            fullscreenLoading: false
        };
    },

    mounted() {
        //获取屏幕尺寸
        this.screenWidth = document.body.clientWidth;
        window.addEventListener("scroll", this.handleScroll);
        window.onresize = () => {
            return (() => {
                this.screenWidth = document.body.clientWidth;
            })();
        };




    },
    destroyed() {
        clearInterval(this.timer);
    },
    watch: {
        screenWidth: function (n) {
            if (n <= 500) {
                this.$emit("controlShow", false);

            }
        },
    },
    created() {
        console.log('传递数据------', this.$route.query)
        this.$emit("controlShow", true);
        // 首页进来跳转到摇一摇
        if(this.$route.query.type){
            setTimeout(() => {
                this.tosCroll()
            }, 200)
        }
        // 判断是否是App登录进来
        if (this.$route.query.from) {
            const queryData = this.$route.query;
            const { accessKey = '', from = '' } = queryData;
            if (from === 'app_pm') {
                this.isApp = true;
                this.isPC = false
            }
            console.log('App数据----------', queryData)
            if (accessKey) {
                setToken(accessKey)
            }
            if (from === 'app_pm' && !accessKey) {
                deleteToken();
            }
            const token = getToken();
            console.log('token', token)
            if (token) {
                const str = this.$route.query.isApp
                //h5携带参数截取
                console.log('携带参数----------------', str.includes('a='), str.split("a=")[1])
                this.isLogin = true
                localStorage.setItem('account', this.$route.query.a ? this.$route.query.a : str.includes('a=')? str.split("a=")[1]:'');
                this.userKey = localStorage.getItem('token');
                this.queryUserAccount(this.userKey);
                this.reverseNum(9)

            } else {
                this.isLogin = false



            }
        }
        
        else {
            if (localStorage.getItem('account')) {

                this.userKey = localStorage.getItem('token');
                this.queryUserAccount(this.userKey);
                this.reverseNum(9)


            }
        }
       
    },
    methods: {
        ...mapActions('common', {
            getTradeWapLink: 'getTradeWapLink',
        }),
        // 去登录
        async toLogin() {
            // 在安卓app
            if (window.android) {
                window.android.gotoLogin();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoLogin()
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
        },
        // 去入金
        async toTrade() {
            // 在安卓app
            if (window.android) {
                window.android.gotoDeposit();
                return
            }
            // 在ios
            if (window.webkit) {
                window.webkit.messageHandlers.gotoDeposit()
                return
            }
            // 在网页浏览器
            const h5LinkUrl = await this.getTradeWapLink();
            const sendData = {
                token: getToken(),
                userStatus: 3,
            }
            window.open(h5LinkUrl + '?sendKey=' + encodeURIComponent(encryptCBC(JSON.stringify(sendData))));
        },
        // 关闭弹窗
        closeDialog() {
            this.showUnderLog = false
            this.timesShow = false;//次数不足
            this.intergralShow = false;//积分不足
            this.vertifyShow = false;//兑换成功
            this.shakeShow = false;//摇到了
            this.shakeDown = false;//积分兑换

        },
        // 关闭兑换弹框
        closeDialogs() {
            if (this.intergral == 100) {
                this.getNumber(100)

            } else {
                this.getNumber(200)

            }
            this.showUnderLog = false
            this.timesShow = false;//次数不足
            this.intergralShow = false;//积分不足
            this.vertifyShow = false;//兑换成功
            this.shakeShow = false;//摇到了
            this.shakeDown = false;//积分兑换
        },
        // 次数不足弹框
        ShakeInOff() {
            this.showUnderLog = true
            this.timesShow = true
        },

        // 兑换次数
        vertifyBtn(num) {
            this.intergral = num
            this.showUnderLog = true
            this.shakeDown = true

        },
        // 规则弹框
        showRule() {
            console.log('111111111111111111')
            this.showDialogs = true
        },
        // 打开历史记录
        historyOff() {
            this.initUserHistory(localStorage.getItem('account'));
            this.showHistory = true
        },
        // 关闭历史记录
        closeHistory() {
            this.showHistory = false
            this.gifsDialog = false
            this.loginDialog = false
        },
        // 参加活动
        joinActivity() {
            // 未登录
            if (!localStorage.getItem('token')) {
                this.actives = 0
      
                this.loginDialog = true
            } else {
                // window.open("http://test.www.rlcvipltd.com/uc/assets/deposit?token=" + localStorage.getItem('token'));//测试
                window.open("https://www.rlcproltd.net/uc/assets/deposit?token=" + localStorage.getItem('token'));


            }
        },
        selectlogin(type) {
            this.actives = type
            this.isNumber=false
            this.form.phone = ''
            this.form.code = ''

        },
        // 客服链接
        live800() {
            window.open(
                this.live800UrlUc
            );
        },
        getTime() {
            const today = new Date()
            const time = today.getTime()
            let endDate = new Date(this.getNextMonthFirstDay()); // this.curStartTime需要倒计时的日期
            let end = endDate.getTime();
            if (time == end || end - time == 0) {
                this.totals = this.fullOpens(20000, 50000)
                localStorage.setItem('totals', this.totals)

            }
        },

        formatDates(dateString) {
            // 解析日期时间字符串  
            const date = new Date(dateString);

            // 检查日期是否有效  
            if (isNaN(date.getTime())) {
                throw new Error('Invalid date string');
            }

            // 使用模板字符串格式化日期和时间  
            const formattedDate = `${date.getFullYear()}年${padZero(date.getMonth() + 1)}月${padZero(date.getDate())}日${padZero(date.getHours() + 8)}:${padZero(date.getMinutes())}`;

            return formattedDate;

            // 辅助函数：在数字前面添加前导零（如果需要）  
            function padZero(num) {
                return num.toString().padStart(2, '0');
            }
        },
        // 点击获取焦点
        focusInput() {
            this.$refs.inputElement.focus();
        },

        // 返回上级页面
        goback() {
            window.location.href = window.location.origin;
        },
        // 控制顶部的定位
        handleScroll() {
            this.scroll =
                document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            let tops = this.isApp ? this.$refs.targetTops.offsetTop - 300: this.$refs.targetElement.offsetTop - 300  ;
            let scrollY = window.scrollY; //获取滚动后的高
            if (this.scroll > 90) {
                this.navBarFixed = true;
            } else {
                this.navBarFixed = false;
            }
            if (scrollY > tops) {
                this.slider = false
            } else {
                this.slider = true
            }

        },

        // 回到顶部
        toTop() {
            document.documentElement.scrollTop = 0;
        },


        // 查询抽奖次数
        initUserNum(attr, id) {
            let initData = {
                turntablenumstatus: {
                    accountid: attr,
                    turntableid: id,
                    platform: 1,
                },
            };
            searchUserNum(initData).then((res) => {
                if (res.status === 0) {
                    this.drawsNumber = res.surplusnum;
                }
            });
        },
        // 查询账户是否为老客户
        queryUserAccount(key) {
            console.log('-------------', localStorage.getItem('account',), Number(localStorage.getItem('account')))
            this.initUserNum(
                localStorage.getItem('account'),
                awardId.newUserID
            );
            this.initUserHistory(localStorage.getItem('account'));


        },

        // 查询历史抽奖结果
        initUserHistory(attr) {
            let initData = {
                TurntablenumStatus: {
                    accountid: attr,
                    turntableid: Number(this.account_type) ? awardId.oldUserID : awardId.newUserID,
                    platform: 1,
                },
            };
            searchUserHistory(initData).then((res) => {
                console.log(res)
                if (res.status === 0) {
                    this.totalNum = res.surplusNum

                    let craigArr = [];
                    res.turntablelogs.map((item) => {
                        craigArr.push({
                            value: item.awardname,
                            id: item.id,
                            time: this.formatDates(item.lotterytime)
                        });
                    });
                    let r = craigArr.filter((item) => {
                        return item.value != '未抽中';
                    });
                    this.historyList = r;
                }
            });
        },
        // ----------------------------领取抽奖次数------------------------

        getNumber(type) {
            if (!localStorage.getItem('account')) {
                this.actives = 0
                this.loginDialog = true

            } else {
                let types = type == 100 ? 7 : type == 200 ? 8 : 9
                exchangeNumNew(types).then((res) => {
                    console.log(res)
                    if (res) {
                        if (types == 7) {
                            this.vertifyNumber = res.stcid7
                            this.vertifyStaus = res.stcid7 >= 4 ? true : false
                            this.reverseNum(7)
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                     
                            setTimeout(() => {
                                this.initUserHistory(localStorage.getItem('account'));
                                loading.close();
                                this.$message({
                                    message: '兑换成功',
                                    type: 'success',
                                });
                            }, 2000)
                        }
                        else if (types == 8) {
                            this.vertifyNumber1 = res.stcid8
                            this.vertifyStaus1 = res.stcid8 >= 5 ? true : false
                            this.reverseNum(8)
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });

                            
                            setTimeout(() => {
                                this.initUserHistory(localStorage.getItem('account'));
                                loading.close();

                                this.$message({
                                    message: '兑换成功',
                                    type: 'success',
                                });
                            },2000)

                        }
                        else {
                            this.getnumber = res.stcid9
                            this.getStatus = res.stcid9 > 0 ? true : false
                            this.reverseNum(9)
                            const loading = this.$loading({
                                lock: true,
                                text: 'Loading',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                            setTimeout(()=>{
                                
                                this.initUserHistory(localStorage.getItem('account'));
                                loading.close();

                                this.$message({
                                    message: '领取成功',
                                    type: 'success',
                                });
                            },2000)
                               
                        
                        }
                    } else {
                        this.$message({
                            message: res.Data,
                            type: 'warning',
                        });

                    }

                })
            }
        },
        // ------------------获取抽奖次数------------------
        reverseNum(type) {
            let types = type == 7 ? 7 : type == 8 ? 8 : 9
            getexchangeNum(types).then((res) => {
                console.log('6666666',res)
                if (res) {
                    if (types == 7) {
                        this.vertifyNumber = res.stcid7
                        this.vertifyStaus = res.stcid7 >= 4 ? true : false

                    }
                    else if (types == 8) {
                        this.vertifyNumber1 = res.stcid8
                        this.vertifyStaus1 = res.stcid8 >= 5 ? true : false
                    } else {
                        this.getnumber = res.stcid9
                        this.getStatus = res.stcid9 > 0 ? true : false
                        this.vertifyNumber = res.stcid7
                        this.vertifyStaus = res.stcid7 >= 4 ? true : false
                        this.vertifyNumber1 = res.stcid8
                        this.vertifyStaus1 = res.stcid8 >= 5 ? true : false
                    }

                } else {
                    if (res.Data == '用户未登录,无权限访问此接口' || res.Data =='登录已失效,请重新登录'){
                       deleteToken()
                    }
                    this.$message({
                        message: res.Data,
                        type: 'warning',
                    });

                }

            })
        },
        // 抽奖
        startCallback() {



            if (!localStorage.getItem('account')) {
                this.actives = 0
                this.loginDialog = true

            } else {
                // if (this.drawsNumber > 0) {
                    let initData = {
                        Account: Number(localStorage.getItem('account')),
                        TurntableId: Number(this.account_type) ? awardId.oldUserID : awardId.newUserID,
                    };
                    luckDraw(initData).then((res) => {
                        if (res.status === 0) {
                            if (res.turntableLog) {
                                this.showOFFd()
                                this.messTitle = res.turntableLog.awardname
                                this.initUserHistory(localStorage.getItem('account'));

                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'warning',
                                });
                            }
                        } else {
                            this.$message({
                                message: '抽取奖励失败！',
                                type: 'warning',
                            });
                        }
                    });
                // } else {
                //     this.$message({
                //         message: '您无可用的抽奖次数！',
                //         type: 'warning',
                //     });
                // }
            }
        },
        // ----------------跳转到指定位置
        tosCroll() {

            const targetElements = this.$refs.targetTops;
            const targetPosition = targetElements.offsetTop
            window.scrollTo({
                top: targetPosition,
                behavior: "smooth",
            });
        },
        // ----------------------------下载----------------
        androidDownLoad() {
            window.open(this.androidMt4DownloadUrl)

        },
        iosDownLoad() {
            window.open(this.iosMt4DownloadUrl)

        },
        androidDownLoad1() {
            window.open(this.androidDownloadUrl)


        },
        iosDownLoad1() {
            window.open(this.iosMt5DownloadUrl)

        },
        // ---------------------------------------------摇一摇动画-----------------------------
        showOFFd() {
            this.gifsDialog = true


            this.gifShow = true
            setTimeout(() => {
                this.gifShow = false
                this.isOpened = true; // 切换状态，触发发光效果

            }, 2000)
            setTimeout(() => {
                this.isOpened = false; // 可选：恢复默认状态
                this.gifsDialog = false
            }, 4000); // 发光持续时间
        },

        // ----------------------------登录注册
        selectAccount(){
            this.isNumber=true
        },
        selectAccount1() {
            this.isNumber = false
        },
        // 提交手机号验证码
        submit(form) {
            if (form.phone && form.code) {
                if (this.actives == 1) {
                    this.handleRegister().then((res) => {
                        console.log('-------------------', res)
                        this.loginDialog = false

                        localStorage.setItem('token', res.Token);
                        localStorage.setItem('account', res.account);

                        this.userKey = localStorage.getItem('token');
                        this.queryUserAccount(this.userKey);
                        this.reverseNum(9)


                    }).catch(() => {
                    })
                } else {
                    const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                   
                        // 手机号登录
                        var params = {
                            isSmsLogin: 1,
                            account: form.phone,
                            password: encryptCBC(form.code),
                            clientId: this.guid,
                            fromType: isWap ? 'wap' : 'pc',
                        }
                  
                    postLogin(params).then((res) => {
                        console.log('-----------', res, res.account)
                        this.loginDialog = false
                        setToken(res.Token)
                        localStorage.setItem('token', res.Token);
                        localStorage.setItem('account', res.account);

                        this.userKey = localStorage.getItem('token');
                        this.queryUserAccount(this.userKey);
                        this.reverseNum(9)

                    });
                }

            } else {
                this.$message({
                    message: '请输入手机号和验证码！',
                    type: 'warning',
                });
            }
        },
        // 账号密码登录
        submit1(form) {
            if (form.phone && form.password) {
               
                    const isWap = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

                    
                        //账号密码登录
                        // 手机号登录
                        var params = {

                            account: form.phone,
                            password: encryptCBC(form.password),
                            clientId: this.guid,
                            fromType: isWap ? 'wap' : 'pc',
                        }
                    
                    postLogin(params).then((res) => {
                        console.log('-----------', res, res.account)
                        this.loginDialog = false
                        setToken(res.Token)
                        localStorage.setItem('token', res.Token);
                        localStorage.setItem('account', res.account);

                        this.userKey = localStorage.getItem('token');
                        this.queryUserAccount(this.userKey);
                        this.reverseNum(9)

                    });
                }

           else {
                this.$message({
                    message: '请输入手机号/交易账号和密码！',
                    type: 'warning',
                });
            }
        },

    },
    deactivated() {
        clearInterval(this.animate)
    },
    beforeDestroy() {
        clearInterval(this.animate)
    },
    computed: {
        ...mapState("common", {
            androidMt4DownloadUrl: "androidMt4DownloadUrl",
            androidDownloadUrl: "androidDownloadUrl",
            iosMt4DownloadUrl: "iosMt4DownloadUrl",
            iosMt5DownloadUrl: "iosMt5DownloadUrl",
            live800UrlUc: 'live800UrlUc',
        }),
    },
};
</script>

<style lang="less" scoped>
.box {
    width: 100%;


    .tabbar {
        width: 100%;
        background-color: #ffffff;

        img {
            margin: 20px 50px;
            width: 130px;
        }
    }

    .navBarFixed {
        position: fixed;
        top: 0;
        z-index: 999;
    }

    .banner {
        width: 100%;

        display: block;
        // padding-top: 75px;
    }

    .banners {
        display: none;
    }

    .top-list {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 33vw;

        img {
            cursor: pointer;
        }
    }

    .top-list img:nth-child(1) {
        margin-right: 64px;
        margin-left: 40px;
    }



    .content {
        width: 100%;
        height: auto;
        // height: 5627px;
        box-sizing: border-box;
        margin: 0 auto;

        background: url(/subject/newYear2025/bg.png) no-repeat;
        background-size: 100% 100%;

        .parent-container {
            display: flex;
            justify-content: center;
            align-items: center;

            .dujia {
                margin-top: 130px;
            }
        }

        .part {
            // max-width: 1400px;
            width: 73%;
            margin: 0 auto;
            padding: 9% 13% 10%;


            .part1 {
                box-sizing: border-box;
                // width: 1317px;
                // height: 1497px;
                max-width: 1317px;
                padding: 10% 13% 10%;

                background: url(/subject/newYear2025/cart.png) no-repeat center center;
                background-size: 100% 100%;
                margin: 0 auto;
                display: block;


                .img-box1 {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    margin-bottom: 40px;


                }

                .img-box1 img:nth-child(1) {
                    height: 40px;
                    width: 362px;
                    margin: 78px 0 51px 0;
                }

                .neirong {

                    display: flex;
                    flex-direction: column;
                    margin: 0 auto;


                }

                .cont {
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        margin-top: 72px;
                    }
                }

                .neirong img:nth-child(1) {
                    width: 362px;
                    height: 40px;
                    margin: 58px 0 41px 0;
                }

                .neirong img:nth-child(3) {
                    width: 856px;
                    height: 110px;
                    margin: 76px 0;

                }

                .anniu {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    margin-top: 35px;
                    cursor: pointer;

                    .anniu-div {
                        width: 312px;
                        height: 94px;
                        background: url(/subject/newYear2025/buttom.png) no-repeat center;
                        background-size: 100%;
                        margin-right: 18px;
                    }
                }

            }

            .wappart1 {
                display: none;
            }

            .part2 {

                max-width: 1317px;
                margin: 0 auto;
                margin-top: 155px;
                padding: 16% 13% 10%;
                background: url(/subject/newYear2025/cart1.png) no-repeat center;
                background-size: 100% 100%;
                background-position: center;
                box-sizing: border-box;

                /* 填充整个小div */
                .clearfix::after {
                    content: "";
                    display: table;
                    clear: both;
                }

                .line260 {
                    width: 100%;
                    height: 260px;
                    margin: 0 auto;
                }

                .detailTable {
                    width: 100%;
                    box-sizing: border-box;

                    margin: 0 auto;


                    /deep/ .has-gutter {
                        background: linear-gradient(to right, #FA2314, #DB2C23);

                        tr {
                            background: none;

                            th {

                                text-align: center;
                                font-size: 20px !important;
                            }
                        }
                    }

                    /deep/ .el-table__row {
                        height: 89px;
                    }

                    /deep/ .el-table__row--striped {
                        height: 80px;
                    }

                    /deep/ .el-table__row td:nth-child(1) {

                        color: #222 !important;
                        font-weight: 600 !important;
                        font-size: 20px !important;
                    }

                    /deep/ .el-table__row td:nth-child(2) {

                        color: #222 !important;
                        font-weight: 600 !important;
                        font-size: 20px !important;
                    }

                    /deep/ .el-table__row td:nth-child(3) {

                        color: #fff !important;
                        font-size: 20px !important;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .cell {
                            background: #ed2b2b !important;
                            width: 96px !important;
                                padding: 20px 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 4px;
                        }

                    }

                    /deep/ .el-table_7_column_20 {

                        color: #FA2314 !important;



                    }

                    /deep/ .el-table .cell {
                        white-space: pre-line;
                    }

                    ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                        background: #fff;
                    }

                    ::v-deep .el-table__header-wrapper {
                        border-collapse: collapse;
                        border: none;
                    }

                }

                /deep/ .el-table__header-wrapper {
                    background: #c7180b !important;
                }

                .anniu {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    margin-top: 35px;
                    cursor: pointer;

                    .anniu-div {
                        width: 312px;
                        height: 94px;
                        background: url(/subject/newYear2025/buttom.png) no-repeat center;
                        background-size: 100%;
                        margin-right: 18px;
                    }
                }
            }

            .part3 {
                max-width: 1317px;
                // width: 1317px;
                // height: 1718px;
                margin: 0 auto;
                margin-top: 100px;
                padding: 10% 146px 126px;
                margin-bottom: 90px;
                background: url(/subject/newYear2025/cart2.png) no-repeat center;
                background-size: 100% 100%;
                background-position: center;
                box-sizing: border-box;
                color: #c7180b;

                font-size: 28px;
                font-weight: 600;

                .title {
                    text-align: center;
                    margin: 44px 0 54px 0;
                }

                .tree {
                    display: block;
                }

                .trees {
                    display: none;
                }

                .history {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 80px;
                    margin-top: 28px;

                    span {
                        cursor: pointer;
                    }

                    img {
                        width: 274px;
                        height: 82px;
                        margin: 0 74px;
                        cursor: pointer;
                    }

                    .shake {
                        display: block;
                    }

                    .shakes {
                        display: none;
                    }
                }

                .drawlist {
                    div {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        img {
                            cursor: pointer;
                        }
                    }
                }

                .drawlist div:nth-child(2) {
                    margin: 40px 0;
                }

                .anniu {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    top: 20px;

                    .anniu-div {
                        width: 362px;
                        height: 155px;
                        background: url(/activity/newYear9911/serve.png) no-repeat center;
                        background-size: 100%;
                    }
                }
            }

            .part4 {
                max-width: 1317px;
                margin: 0 auto;
                margin-top: 100px;
                padding: 20% 80px 108px;
                margin-bottom: 90px;
                background: url(/subject/newYear2025/cart3.png) no-repeat center;
                background-size: 100% 100%;
                background-position: center;

                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;

                .left {
                    border: 2px solid #ffa74c;
                    background: #fff;
                    width: 360px;
                    height: 636px;
                    position: absolute;
                    top: 26%;
                    left: 80px;
                    border-radius: 20px;
                    z-index: 6;
                    display: block;

                    .top-box {
                        border-bottom: 2px solid #ffa74c;
                        display: flex;
                        align-items: center;
                        border-radius: 20px;
                        font-size: 24px;
                        font-weight: 600;
                        height: 86px;
                    }

                    .flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .default {
                        width: 185px;
                        height: 86px;
                        border-radius: 20px;

                    }

                    .active {
                        width: 185px;
                        height: 86px;
                        border-radius: 20px;
                        background: url(/subject/newYear2025/bg1.png) no-repeat center;
                        background-size: 100% 100%;
                        background-position: center;

                    }

                    .pcmt4 {
                        display: block;
                    }

                    .wapmt4 {
                        display: none;
                    }

                    .default,
                    .active {
                        span {
                            width: 97px;
                        }
                    }

                    .mt4cont,
                    .mt5cont {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;

                        .codeBoxs {
                            width: 112px;
                            height: 112px;
                            margin: 30px 0 24px 0;
                        }

                        .canvasCode {
                            width: 112px;
                            height: 112px;
                        }

                        .ios {
                            background: #ff2e21;
                            width: 150px;
                            height: 40px;
                            border-radius: 20px;
                            font-size: 22px;
                            color: #fff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                    }

                    .cont {
                        font-size: 16px;
                        line-height: 20px;
                        padding: 0 40px;
                        color: #222;
                        margin-top: 20px;
                    }
                }

                .lefts {
                    display: none;
                }

                .phone {
                    display: block;
                }

                .phones {
                    display: none;
                }

                .right {
                    position: absolute;
                    top: 40%;
                    right: 60px;
                }

            }
        }
    }

    .sliderBox {
        width: 302px;
        height: 384px;
        background: url(/subject/newYear2025/icon.png) no-repeat;
        background-size: 100% 100%;
        position: relative;
        position: fixed;
        top: 80%;
        right: 0;
        padding-left: 24px;
        transform: translate(0%, -50%);
        text-align: center;
        line-height: 580px;
        cursor: pointer;


        .user-info-close {
            position: absolute;
            bottom: -60px;
            left: 50%;
            z-index: 5;
            transform: translate(-50%, 0);
            cursor: pointer;
            display: block;
        }
    }

    .showdialog {
        position: relative;
       
    }

    .dialog {
        position: relative;
        position: fixed;
        top: 60%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 621px;
        height: 880px;
        // box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
        background: url(/subject/newYear2025/bg3.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 14px;

        z-index: 999;
        padding: 40px 54px 68px;
        box-sizing: border-box;
        overflow: hidden;

        h3 {
            color: #fff;
            font-weight: 600;
            position: absolute;
            top: -9px;
            right: 45%;
            cursor: pointer;
        }

        .dialogContent {
            box-sizing: border-box;
            padding: 15px;
            background: url("/activity/mayPage/rulesBackground.png") no-repeat;
            background-size: 100% 100%;
            overflow-y: scroll;
            height: 880px;
            padding-bottom: 140px;

            h3 {
                color: #d88f4f;
                text-align: center;
            }

            li {
                font-size: 16px;
                color: #333;
                font-weight: 600;
                line-height: 34px;
                margin: 24px 0 16px 0;

                span {
                    font-weight: 600;
                    color: #ed0202;
                    font-size: 20px;
                    margin-bottom: 24px;
                }

                img {
                    width: 100%;
                    height: auto;
                    margin: 20px 0;
                }


            }
        }

        .dialogContent::-webkit-scrollbar {
            display: none;
        }

        &::-webkit-scrollbar {
            width: 5px;
        }

        &::-webkit-scrollbar-track {
            background-color: #fedfba;
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
        }

        &::-webkit-scrollbar-thumb {
            background-color: #d88f4f;
            -webkit-border-radius: 2em;
            -moz-border-radius: 2em;
            border-radius: 2em;
        }

        .detailTable {}
    }

    .closer {
        width: 50px;
        height: auto;
        position: fixed;
        top: 9%;
        right: 27%;
        cursor: pointer;

        z-index: 9999;
    }

    .dark {
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.5;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 101;
    }

    .underlogs,
    .underlogs2,
    .underlogs1 {
        ::v-deep .underlogs .el-dialog__header {
            display: none !important;
        }

    }

    /deep/ .el-dialog__header {
        display: none !important;
    }

    /deep/ .el-dialog__body {
        background: rgba(0, 0, 0, 0.5);

        border: none !important;
    }

    // 次数不足弹框
    .underlog {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        .closes {
            cursor: pointer;
            margin-top: 44px;
        }

        position: relative;
        position: fixed;
        top: 37%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 482px;
        height: 460px;
        background: url(/subject/newYear2025/register.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 80px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;
        font-weight: 600;

        .title {
            margin: 46px 0 0 0;
        }


    }

    .underlogs {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 432px;
        height: 368px;
        background: url(/subject/newYear2025/history.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 80px 20px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;
        font-weight: 600;

        .titles {
            position: absolute;
            top: 5%;
            right: 41%;
            color: #fff;
        }

        .lists {
            display: flex;
            flex-direction: column;
            height: 368px;

            overflow-y: scroll;
            line-height: 40px;
        }

        .lists::-webkit-scrollbar {
            display: none;
        }


    }

    .underlogs2 {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        .gifimg {
            width: 732px;
            height: 577px;
        }

        position: relative;
        position: fixed;
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);

        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 80px 20px;
        box-sizing: border-box;
        font-size: 24px;
        color: #333;
        font-weight: 600;





    }

    .loginDialogs {
        .closer {
            position: absolute;
            top: -55px;
            right: -44px;
            width: 50px;
            height: 50px;
        }

        position: relative;
        position: fixed;
        top: 33%;
        left: 50%;
        transform: translate(-50%, -50%);

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
            width: 332px !important;
            height: 150px !important;
        }

        // ----------------登录-----------
        .login {

            margin: 0 auto;

            background: url(/subject/newYear2025/login-bg.png) no-repeat;
            background-size: 100% 100%;
            border-radius: 10px;
            padding: 120px 0 40px;

            width: 432px;
            height: 220px;

            position: relative;

            .logintitle {
                position: absolute;
                width: 38%;
                top: 5%;
                left: 32%;
                display: flex;
                align-items: center;
                justify-content: space-between;

                font-size: 20px;
                color: #fff;
                font-weight: 600;

            }

            .logxiadan {
                width: 70%;
                margin: 0 auto;
                margin-bottom: 10px;

                img {
                    width: 100%;
                }
            }

            .interactive {
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;

                input:focus {
                    outline: none;
                }

                input {
                    width: 80%;
                    height: 3vw;
                    background: #fff;
                    border: 1px solid #fff;
                    border-radius: 10px;
                    font-size: 16px;
                    text-indent: 25px;
                    list-style: none;
                    border: 1px solid #e6e6e6;
                }

                .codeBox {
                    width: 80%;
                    position: relative;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin: 16px 0 26px 0;

                    input {
                        width: 100%;
                    }

                    span {
                        width: 160px;
                        height: 3.2vw;
                        line-height: 3.2vw;
                        font-size: 16px;
                        border-radius: 10px;
                        background: linear-gradient(to bottom, #ffefcc, #ffc994);
                        width: 142px;

                        background: #ff1220;

                        text-align: center;
                        color: #fff;
                        position: absolute;
                        top: 0vw;
                        right: 0px;
                        cursor: pointer;
                    }
                }

                .loginBtn {
                    width: 20%;
                    cursor: pointer;
                    position: relative;
                    top: 15px;
                }
                .titleLogin{
                    line-height: 20px;
                        font-size: 16px;
                        color: #FF9019;
                        font-weight: 700;
                        cursor: pointer;
                        text-align: right;
                        display: flex;
                        align-items: end;
                        margin-bottom: 10px;
                        justify-content: end;
                        width: 80%;
                }
            }


            .buttom {
                width: 240px;
                height: 54px;
                background: #ff1220;
                border-radius: 8px;
                text-align: center;
                line-height: 54px;
                color: #fff;
                font-size: 22px;
                font-weight: 700;
            }

        }

        .logins {
            background: url(/subject/newYear2025/bg2.png) no-repeat;
            background-size: 100% 100%;
        }
    }

    // 动画
    .blind-box {
        width: 200px;
        height: 200px;
        // background: #fff;
        // border: 2px solid #aaa;
        background: url(/subject/newYear2025/boll.png) no-repeat;
        background-size: 100% 100%;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        color: #FA2314;
        cursor: pointer;
        transition: transform 0.3s, box-shadow 0.3s;
    }

    .blind-box.glowing {

        animation: glow 1s infinite alternate;
    }

    @keyframes glow {
        0% {
            box-shadow: 0 0 10px #ffcc00, 0 0 20px #ffcc00;
            transform: scale(1.05);
        }

        100% {
            box-shadow: 0 0 20px #ff9900, 0 0 40px #ff9900;
            transform: scale(1.1);
        }


    }

}



@media screen and (min-width: 1264px) and (max-width: 1700px) {
    .box {
        width: 100%;


        .tabbar {
            width: 100%;
            background-color: #ffffff;

            img {
                margin: 20px 50px;
                width: 130px;
            }
        }

        .navBarFixed {
            position: fixed;
            top: 0;
            z-index: 999;
        }

        .banner {
            width: 100%;

            display: block;
            // padding-top: 75px;
        }

        .banners {
            display: none;
        }

        .top-list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 33vw;

            img {
                cursor: pointer;
            }
        }

        .top-list img:nth-child(1) {
            margin-right: 64px;
            margin-left: 40px;
        }



        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/newYear2025/bg.png) no-repeat;
            background-size: 100% 100%;

            .parent-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .dujia {
                    margin-top: 130px;
                }
            }

            .part {
                // max-width: 1400px;
                width: 73%;
                margin: 0 auto;
                padding: 9% 13% 10%;


                .part1 {
                    box-sizing: border-box;
                    // width: 1317px;
                    // height: 1497px;
                    max-width: 1317px;
                    padding: 10% 13% 10%;

                    background: url(/subject/newYear2025/cart.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;
                    display: block;


                    .img-box1 {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin-bottom: 40px;


                    }

                    .img-box1 img:nth-child(1) {
                        height: 40px;
                        width: 362px;
                        margin: 78px 0 51px 0;
                    }

                    .neirong {

                        display: flex;
                        flex-direction: column;
                        margin: 0 auto;


                    }

                    .cont {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            margin-top: 72px;
                        }
                    }

                    .neirong img:nth-child(1) {
                        width: 362px;
                        height: 40px;
                        margin: 58px 0 41px 0;
                    }

                    .neirong img:nth-child(3) {
                        width: 856px;
                        height: 110px;
                        margin: 76px 0;

                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-top: 35px;

                        .anniu-div {
                            width: 312px;
                            height: 94px;
                            background: url(/subject/newYear2025/buttom.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }
                    }

                }

                .wappart1 {
                    display: none;
                }

                .part2 {

                    max-width: 1317px;
                    margin: 0 auto;
                    margin-top: 155px;
                    padding: 16% 13% 10%;
                    background: url(/subject/newYear2025/cart1.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }

                    .line260 {
                        width: 100%;
                        height: 260px;
                        margin: 0 auto;
                    }

                    .detailTable {
                        width: 100%;
                        box-sizing: border-box;

                        margin: 0 auto;

                        /deep/ .has-gutter {
                            tr {
                                background: linear-gradient(to right, #FA2314, #DB2C23);

                            }
                        }

                        /deep/ .el-table__row {
                            height: 89px;
                        }

                        /deep/ .el-table__row--striped {
                            height: 80px;
                        }

                        /deep/ .el-table__row td:nth-child(1) {

                            color: #222 !important;
                            font-weight: 600 !important;
                            font-size: 20px !important;
                        }

                        /deep/ .el-table__row td:nth-child(2) {

                            color: #222 !important;
                            font-weight: 600 !important;
                            font-size: 20px !important;
                        }

                        /deep/ .el-table__row td:nth-child(3) {

                            color: #fff !important;
                            font-size: 20px !important;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .cell {
                                background: #ed2b2b !important;
                                width: 96px !important;
                                padding: 20px 0;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 4px;
                            }

                        }

                        /deep/ .el-table_7_column_20 {

                            color: #FA2314 !important;



                        }

                        /deep/ .el-table .cell {
                            white-space: pre-line;
                        }

                        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                            background: #fff;
                        }

                        ::v-deep .el-table__header-wrapper {
                            border-collapse: collapse;
                            border: none;
                        }

                    }

                    /deep/ .el-table__header-wrapper {
                        background: #c7180b !important;
                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-top: 35px;

                        .anniu-div {
                            width: 312px;
                            height: 94px;
                            background: url(/subject/newYear2025/buttom.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }
                    }
                }

                .part3 {
                    max-width: 1317px;
                    // width: 1317px;
                    // height: 1718px;
                    margin: 0 auto;
                    margin-top: 100px;
                    padding: 10% 60px 126px;
                    margin-bottom: 90px;
                    background: url(/subject/newYear2025/cart2.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;
                    color: #c7180b;

                    font-size: 28px;
                    font-weight: 600;

                    .title {
                        text-align: center;
                        margin: 44px 0 54px 0;
                    }

                    .tree {
                        display: block;
                        width: 100%;
                    }

                    .trees {
                        display: none;
                    }

                    .history {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 80px;
                        margin-top: 28px;

                        span {
                            cursor: pointer;
                        }

                        img {
                            width: 274px;
                            height: 82px;
                            margin: 0 74px;
                            cursor: pointer;
                        }

                        .shake {
                            display: block;
                        }

                        .shakes {
                            display: none;
                        }
                    }

                    .drawlist {
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;

                            img {
                                cursor: pointer;
                            }
                        }
                    }

                    .drawlist div:nth-child(2) {
                        margin: 40px 0;
                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        top: 20px;

                        .anniu-div {
                            width: 362px;
                            height: 155px;
                            background: url(/activity/newYear9911/serve.png) no-repeat center;
                            background-size: 100%;
                        }
                    }
                }

                .part4 {
                    max-width: 1317px;
                    margin: 0 auto;
                    margin-top: 100px;
                    padding: 20% 80px 108px;
                    margin-bottom: 90px;
                    background: url(/subject/newYear2025/cart3.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;

                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;

                    .left {
                        border: 2px solid #ffa74c;
                        background: #fff;
                        width: 170px;
                        height: 586px;
                        position: absolute;
                        top: 20%;
                        left: 80px;
                        border-radius: 20px;
                        z-index: 6;
                        display: block;

                        .top-box {
                            border-bottom: 2px solid #ffa74c;
                            display: flex;
                            align-items: center;
                            border-radius: 20px;
                            font-size: 12px;
                            font-weight: 600;
                            height: 43px;
                        }

                        .flex {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .default {
                            width: 135px;
                            height: 43px;
                            border-radius: 20px;

                        }

                        .active {
                            width: 135px;
                            height: 43px;
                            border-radius: 20px;
                            background: url(/subject/newYear2025/bg1.png) no-repeat center;
                            background-size: 100% 100%;
                            background-position: center;

                        }

                        .pcmt4 {
                            display: block;
                        }

                        .wapmt4 {
                            display: none;
                        }

                        .default,
                        .active {
                            span {
                                width: 48px;
                            }
                        }

                        .mt4cont,
                        .mt5cont {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            flex-direction: column;

                            .codeBoxs {
                                width: 112px;
                                height: 112px;
                                margin: 30px 0 24px 0;
                            }

                            .canvasCode {
                                width: 112px;
                                height: 112px;
                            }

                            .ios {
                                background: #ff2e21;
                                width: 75px;
                                height: 27px;
                                border-radius: 20px;
                                font-size: 11px;
                                color: #fff;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                        }

                        .cont {
                            font-size: 14px;
                            line-height: 16px;
                            padding: 0 20px;
                            color: #222;
                            margin-top: 20px;
                        }
                    }

                    .lefts {
                        display: none;
                    }

                    .phone {
                        display: block;
                    }

                    .phones {
                        display: none;
                    }

                    .right {
                        position: absolute;
                        top: 26%;
                        right: 60px;
                        width: 30%;
                    }

                }
            }
        }

        .sliderBox {
            width: 302px;
            height: 384px;
            background: url(/subject/newYear2025/icon.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            position: fixed;
            top: 80%;
            right: 0;
            padding-left: 24px;
            transform: translate(0%, -50%);
            text-align: center;
            line-height: 580px;
            cursor: pointer;

            .allCode {
                width: 140px;
            }

            .user-info-close {
                position: absolute;
                bottom: -60px;
                left: 50%;
                z-index: 5;
                transform: translate(-50%, 0);
                cursor: pointer;
            }
        }

        .showdialog {
            position: relative;
        }

        .dialog {
            position: relative;
            position: fixed;
            top: 85%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 621px;
            height: 880px;
            // box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
            background: url(/subject/newYear2025/bg3.png) no-repeat;
            background-size: 100% 100%;
            border-radius: 14px;
            overflow-y: scroll;
            z-index: 999;
            padding: 40px 54px 68px;
            box-sizing: border-box;

            h3 {
                color: #fff;
                font-weight: 600;
                position: absolute;
                top: -9px;
                right: 45%;
                cursor: pointer;
            }

            .dialogContent {
                box-sizing: border-box;
                padding: 15px;
                overflow: hidden;
                background: url("/activity/mayPage/rulesBackground.png") no-repeat;
                background-size: 100% 100%;
                overflow-y: scroll;
                height: 800px;
                padding-bottom: 300px;

                h3 {
                    color: #d88f4f;
                    text-align: center;
                }

                li {
                    font-size: 16px;
                    color: #333;
                    font-weight: 600;
                    line-height: 34px;
                    margin: 24px 0 16px 0;

                    span {
                        font-weight: 600;
                        color: #ed0202;
                        font-size: 20px;
                        margin-bottom: 24px;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }


                }
            }

            .dialogContent::-webkit-scrollbar {
                display: none;
            }

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-track {
                background-color: #fedfba;
                -webkit-border-radius: 2em;
                -moz-border-radius: 2em;
                border-radius: 2em;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #d88f4f;
                -webkit-border-radius: 2em;
                -moz-border-radius: 2em;
                border-radius: 2em;
            }

            .detailTable {}
        }

        .closer {
            width: 30px;
            height: auto;
            position: fixed;
            top: 15%;
            right: 27%;
            cursor: pointer;

            z-index: 9999;
        }

        .dark {
            width: 100%;
            height: 100%;
            background: #000;
            opacity: 0.5;
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 101;
        }

        .underlogs,
        .underlogs1 {
            ::v-deep .underlogs .el-dialog__header {
                display: none !important;
            }

        }

        /deep/ .el-dialog__header {
            display: none !important;
        }

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
        }

        // 次数不足弹框
        .underlog {
            .closer {
                position: absolute;
                top: -55px;
                right: -44px;
                width: 50px;
                height: 50px;
            }

            .closes {
                cursor: pointer;
                margin-top: 44px;
            }

            position: relative;
            position: fixed;
            top: 37%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 482px;
            height: 460px;
            background: url(/subject/newYear2025/register.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 80px;
            box-sizing: border-box;
            font-size: 24px;
            color: #333;
            font-weight: 600;

            .title {
                margin: 46px 0 0 0;
            }


        }

        .underlogs {
            .closer {
                position: absolute;
                top: -55px;
                right: -44px;
                width: 50px;
                height: 50px;
            }

            position: relative;
            position: fixed;
            top: 33%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 432px;
            height: 368px;
            background: url(/subject/newYear2025/history.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 80px 20px;
            box-sizing: border-box;
            font-size: 24px;
            color: #333;
            font-weight: 600;

            .titles {
                position: absolute;
                top: 5%;
                right: 41%;
                color: #fff;
            }

            .lists {
                display: flex;
                flex-direction: column;
                align-items: center;

                line-height: 40px;
            }


        }

    }
}

@media screen and (max-width: 500px) {
    .box {
        width: 100%;


        

        .navBarFixed {
            position: fixed;
            top: 0;
            z-index: 999;
        }

        .banner {
            width: 100%;

            display: none;
            // padding-top: 75px;
        }

        .banners {
            display: block;
            width: 100%;
        }

        .top-list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 50%;

            img {
                cursor: pointer;
                width: 40%;
            }
        }

        .top-list img:nth-child(1) {
            margin-right: 20px;
            margin-left: 0px;
        }



        .content {
            width: 100%;
            height: auto;
            // height: 5627px;
            box-sizing: border-box;
            margin: 0 auto;

            background: url(/subject/newYear2025/bg.png) no-repeat;
            background-size: 100% 100%;

            .parent-container {
                display: flex;
                justify-content: center;
                align-items: center;

                .dujia {
                    margin-top: 130px;
                }
            }

            .part {
                // max-width: 1400px;
                width: 94%;
                margin: 0 auto;
                padding: 4% 2% 10%;

                .part1 {
                    display: none;
                }

                .wappart1 {
                    display: block;
                    box-sizing: border-box;
                    // width: 1317px;
                    // height: 1497px;
                    max-width: 1317px;
                    padding: 10% 4% 10%;

                    background: url(/subject/newYear2025/wap/bg2.png) no-repeat center center;
                    background-size: 100% 100%;
                    margin: 0 auto;



                    .img-box1 {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        margin-bottom: 20px;


                    }

                    .img-box1 img:nth-child(1) {
                        height: 26px;
                        width: 68%;
                        margin: 60px 0 24px 0;
                    }

                    .neirong {

                        display: flex;
                        flex-direction: column;
                        margin: 0 auto;


                    }

                    .cont {
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            margin-top: 72px;
                            width: 100%;
                        }
                    }

                    .neirong img:nth-child(1) {
                        width: 68%;
                        height: 26px;
                        margin: 14px 0 20px 0;
                    }

                    .neirong img:nth-child(2) {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-left: 10%;
                    }

                    .neirong img:nth-child(3) {
                        width: 856px;
                        height: 110px;
                        margin: 76px 0;

                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-top: 35px;

                        .anniu-div {
                            width: 40%;
                            height: 78px;
                            background: url(/subject/newYear2025/wap/request.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }

                        .anniu-img {
                            width: 40%;

                        }
                    }

                }

                .part2 {

                    max-width: 1317px;
                    margin: 0 auto;
                    margin-top: 60px;
                    padding: 15% 4% 10%;
                    background: url(/subject/newYear2025/wap/bg3.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;

                    /* 填充整个小div */
                    .clearfix::after {
                        content: "";
                        display: table;
                        clear: both;
                    }

                    .line260 {
                        width: 100%;
                        height: 260px;
                        margin: 0 auto;
                    }

                    .detailTable {
                        width: 100%;
                        box-sizing: border-box;

                        margin: 0 auto;
                        margin-top: 58px;

                        /deep/ .has-gutter {
                            tr {
                                background: linear-gradient(to right, #FA2314, #DB2C23);

                            }
                        }

                        /deep/ .has-gutter {
                            background: linear-gradient(to right, #FA2314, #DB2C23);

                            tr {
                                background: none;

                                th {

                                    text-align: center;
                                    font-size: 12px !important;
                                }
                            }
                        }

                        /deep/ .el-table__row {
                            height: 54px;
                        }

                        /deep/ .el-table__row--striped {
                            height: 80px;
                        }

                        /deep/ .el-table__row td:nth-child(1) {

                            color: #222 !important;
                            font-weight: 600 !important;
                            font-size: 14px !important;
                        }

                        /deep/ .el-table__row td:nth-child(2) {

                            color: #222 !important;
                            font-weight: 600 !important;
                            font-size: 14px !important;
                        }

                        /deep/ .el-table__row td:nth-child(3) {

                            color: #fff !important;
                            font-size: 20px !important;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .cell {
                                background: #ed2b2b !important;
                                width: 58px !important;
                                height: 26px !important;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border-radius: 4px;
                                font-size: 14px;
                            }

                        }

                        /deep/ .el-table_7_column_20 {

                            color: #FA2314 !important;




                        }

                        /deep/ .el-table .cell {
                            white-space: pre-line;
                        }

                        ::v-deep .el-table--striped .el-table__body tr.el-table__row--striped td {
                            background: #fff;
                        }

                        ::v-deep .el-table__header-wrapper {
                            border-collapse: collapse;
                            border: none;
                        }

                    }

                    /deep/ .el-table__header-wrapper {
                        background: #c7180b !important;

                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        margin-top: 35px;

                        .anniu-div {
                            width: 40%;
                            height: 78px;
                            background: url(/subject/newYear2025/wap/request.png) no-repeat center;
                            background-size: 100%;
                            margin-right: 18px;
                        }

                        .anniu-img {
                            width: 40%;

                        }
                    }
                }

                .part3 {
                    max-width: 1317px;
                    // width: 1317px;
                    // height: 1718px;
                    margin: 0 auto;
                    margin-top: 60px;
                    padding: 10% 4% 63px;
                    margin-bottom: 90px;
                    background: url(/subject/newYear2025/wap/bg4.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;
                    box-sizing: border-box;
                    color: #c7180b;

                    font-size: 28px;
                    font-weight: 600;

                    .title {
                        text-align: center;
                        margin: 44px 0 27px 0;
                        font-size: 20px;
                    }

                    .tree {
                        display: none;
                    }

                    .trees {
                        display: block;
                        width: 100%;
                    }

                    .history {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-bottom: 40px;
                        margin-top: 28px;
                        font-size: 14px;
                        font-weight: 600;
                        white-space: nowrap;

                        img {
                            width: 46%;
                            height: 50px;
                            margin: 0 20px;
                            cursor: pointer;
                        }

                        .shake {
                            display: none;
                        }

                        .shakes {
                            display: block;
                        }
                    }

                    .drawlist {
                        div {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            font-size: 14px;
                            font-weight: 600;

                            img {
                                cursor: pointer;
                                width: 24%;
                                height: 36px;
                            }
                        }
                    }

                    .drawlist div:nth-child(2) {
                        margin: 40px 0;
                    }

                    .anniu {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        top: 20px;

                        .anniu-div {
                            width: 100%;
                            height: 155px;
                            background: url(/activity/newYear9911/serve.png) no-repeat center;
                            background-size: 100%;
                        }
                    }
                }

                .part4 {
                    max-width: 1317px;
                    margin: 0 auto;
                    margin-top: 100px;
                    padding: 20% 4% 54px;
                    margin-bottom: 90px;
                    background: url(/subject/newYear2025/wap/bg5.png) no-repeat center;
                    background-size: 100% 100%;
                    background-position: center;

                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    position: relative;

                    .left {
                        display: none;
                    }

                    .right {

                        display: none;
                    }

                    .phone {
                        width: 100%;
                        display: none;
                    }

                    .phones {
                        display: block;
                        width: 100%;

                    }

                    .lefts {
                        margin-top: 70px;
                        display: block;
                        border: 2px solid #ffa74c;
                        background: #fff;
                        width: 100%;
                        height: 240px;

                        border-radius: 20px;

                        .top-box {
                            border-bottom: 2px solid #ffa74c;
                            display: flex;
                            align-items: center;
                            border-radius: 20px;
                            font-size: 16px;
                            font-weight: 600;
                            height: 54px;
                        }

                        .flex {
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .default {
                            width: 185px;
                            height: 54px;
                            border-radius: 20px;

                        }

                        .active {
                            width: 185px;
                            height: 54px;
                            border-radius: 20px;
                            background: url(/subject/newYear2025/bg1.png) no-repeat center;
                            background-size: 100% 100%;
                            background-position: center;

                        }

                        .pcmt4 {
                            display: none;
                        }

                        .wapmt4 {
                            display: block;
                        }

                        .default,
                        .active {
                            span {

                                white-space: nowrap;
                                text-align: center;
                            }
                        }

                        .mt4cont,
                        .mt5cont {
                            display: flex;
                            align-items: center;
                            justify-content: center;


                            div {
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                            }

                            div img:nth-child(1) {
                                width: 40px;
                                height: 40px;
                                margin: 36px 0 23px 0;
                            }

                            div img:nth-child(2) {
                                width: 78%;
                                height: 40px;
                            }

                            .ios {
                                background: #ff2e21;
                                width: 150px;
                                height: 40px;
                                border-radius: 20px;
                                font-size: 22px;
                                color: #fff;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }

                        }

                        .cont {
                            display: none;
                        }
                    }
                }
            }
        }

        .sliderBox {
            width: 122px;
            height: 214px;
            background: url(/subject/newYear2025/wap/icon.png) no-repeat;
            background-size: 100% 100%;
            position: relative;
            position: fixed;
            top: 75%;
            right: 0;
            padding-left: 24px;
            transform: translate(0%, -50%);
            text-align: center;
            line-height: 580px;



            .user-info-close {
                display: none;
            }
        }

        .showdialog {
            position: relative;
            .closer {
                    width: 25px;
                    height: auto;
                    position: fixed;
                    top: 1%;
                    right: 2%;
                    cursor: pointer;
            
                    z-index: 9999;
                }
        }

        .dialog {
            position: relative;
            position: fixed;
            top: 53%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 94%;
            height: 640px;
            // box-shadow: 0px 0px 95px 0px rgba(187, 188, 192, 0.1);
            background: url(/subject/newYear2025/bg3.png) no-repeat;
            background-size: 100% 100%;
            border-radius: 14px;
            overflow-y: scroll;
            z-index: 999;
            padding: 40px 20px 68px;
            box-sizing: border-box;

            h3 {
                color: #fff;
                font-weight: 600;
                position: absolute;
                top: -8px;
                right: 41%;
                cursor: pointer;
                font-size: 14px;
            }

            .dialogContent {
                box-sizing: border-box;
                padding: 15px;
          
                background: url("/activity/mayPage/rulesBackground.png") no-repeat;
                background-size: 100% 100%;

                h3 {
                    color: #d88f4f;
                    text-align: center;
                }

                li {
                    font-size: 12px;
                    color: #333;
                    font-weight: 600;
                    line-height: 34px;
                    margin: 24px 0 16px 0;

                    span {
                        font-weight: 700;
                        color: #ed0202;
                        font-size: 14px;
                        margin-bottom: 24px;
                    }

                    img {
                        width: 100%;
                        height: auto;
                        margin: 20px 0;
                    }


                }
            }

            &::-webkit-scrollbar {
                width: 5px;
            }

            &::-webkit-scrollbar-track {
                background-color: #fedfba;
                -webkit-border-radius: 2em;
                -moz-border-radius: 2em;
                border-radius: 2em;
            }

            &::-webkit-scrollbar-thumb {
                background-color: #d88f4f;
                -webkit-border-radius: 2em;
                -moz-border-radius: 2em;
                border-radius: 2em;
            }
        }

        .closer {
            width: 25px;
            height: auto;
            position: fixed;
            top: 11%;
            right: 2%;
            cursor: pointer;

            z-index: 9999;
        }

        .dark {
            width: 100%;
            height: 100%;
            background: #000;
            opacity: 0.5;
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 101;
        }

        .underlogs {
            ::v-deep .underlogs .el-dialog__header {
                display: none !important;
            }

        }

        /deep/ .el-dialog__header {
            display: none !important;
        }

        /deep/ .el-dialog__body {
            background: rgba(0, 0, 0, 0.5);

            border: none !important;
            padding: 0 !important;
        }

        // 次数不足弹框
        .underlog {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            .closes {
                cursor: pointer;
                width: 156px;
                height: 42px;
                margin-top: 0;
            }

            position: relative;
            position: fixed;
            top: 37%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            height: 324px;
            background: url(/subject/newYear2025/register.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 40px;
            box-sizing: border-box;

            span {
                margin: 23px 0 22px 0;
                font-size: 14px;
            }

        }

        .underlog img:nth-child(2) {
            width: 50px;
            height: 62px;
        }

        .underlogs {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            position: relative;
            position: fixed;
            top: 33%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            height: 324px;
            background: url(/subject/newYear2025/wap/history.png) no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            padding: 80px 20px 40px;
            box-sizing: border-box;
            font-size: 24px;
            color: #333;
            font-weight: 600;

            .titles {
                position: absolute;
                top: 5%;
                right: 41%;
                color: #fff;
                font-size: 16px;
            }

            .lists {
                display: flex;
                flex-direction: column;
                align-items: center;
                font-size: 16px;
                line-height: 30px;
            }


        }

        .loginDialogs {
            .closer {
                position: absolute;
                top: -40px;
                right: -16px;
                width: 25px;
                height: 25px;
            }

            position: relative;
            position: fixed;
            top: 33%;
            left: 50%;
            transform: translate(-50%, -50%);



            // ----------------登录-----------
            .login {

                margin: 0 auto;

                background: url(/subject/newYear2025/wap/loginbg.png) no-repeat;
                background-size: 100% 100%;
                border-radius: 10px;
                padding: 120px 0 40px;

                width: 294px;
                height: 220px;

                position: relative;

                .logintitle {
                    position: absolute;
                    width: 38%;
                    top: 5%;
                    left: 32%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    font-size: 20px;
                    color: #fff;
                    font-weight: 600;

                }

                .logxiadan {
                    width: 70%;
                    margin: 0 auto;
                    margin-bottom: 10px;

                    img {
                        width: 100%;
                    }
                }

                .interactive {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    align-items: center;

                    input:focus {
                        outline: none;
                    }

                    input {
                        width: 80%;
                        height: 15vw;
                        background: #fff;
                        border: 1px solid #fff;
                        border-radius: 10px;
                        font-size: 16px;
                        text-indent: 25px;
                        list-style: none;
                        border: 1px solid #e6e6e6;
                    }

                    .codeBox {
                        width: 80%;
                        position: relative;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin: 16px 0 26px 0;

                        input {
                            width: 100%;
                        }

                        span {
                            width: 160px;
                            height: 15vw;
                            line-height: 15vw;
                            font-size: 16px;
                            border-radius: 10px;
                            background: linear-gradient(to bottom, #ffefcc, #ffc994);
                            width: 100px;

                            background: #ff1220;

                            text-align: center;
                            color: #fff;
                            position: absolute;
                            top: 0vw;
                            right: 0px;
                            cursor: pointer;
                        }
                    }

                    .loginBtn {
                        width: 20%;
                        cursor: pointer;
                        position: relative;
                        top: 15px;
                    }
                }


                .buttom {
                    width: 240px;
                    height: 54px;
                    background: #ff1220;
                    border-radius: 8px;
                    text-align: center;
                    line-height: 54px;
                    color: #fff;
                    font-size: 22px;
                    font-weight: 700;
                }

            }

            .logins {
                background: url(/subject/newYear2025/wap/register.png) no-repeat;
                background-size: 100% 100%;
            }
        }

        .underlogs2 {
            width: 100%;

            .gifimg {
                width: 100%;
                height: 277px;
            }
        }
    }

}
</style>
